import { render, staticRenderFns } from "./ItemFilterModalPremiumMarketFilter.vue?vue&type=template&id=580df4f0&scoped=true"
import script from "./ItemFilterModalPremiumMarketFilter.vue?vue&type=script&lang=js"
export * from "./ItemFilterModalPremiumMarketFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "580df4f0",
  null
  
)

export default component.exports